import styled from 'styled-components/macro';

export const SignInContainer = styled.div`
  max-width: 400px;
  margin: 0 auto;
  padding: 25px 0;
  font-family: 'Raleway', sans-serif;
`;

export const Container = styled.div`
  max-width: 80vw;
  margin: 0 auto;
  padding: 25px 0;
`;

export const PageHeading = styled.h1`
  margin-bottom: 10px;
  font-size: 24px;
  text-align: center;
  font-family: 'Raleway', sans-serif;
  font-weight: 700;
`;

export const PageSubHeading = styled.p`
  margin-bottom: 25px;
  font-size: 16px;
  text-align: center;
  font-family: 'Raleway', sans-serif;
  font-weight: 500;
`;

export const ErrorText = styled.p`
  color: red;
  font-size: 12px;
  font-style: italic;
`;

export const StyledNavbar = styled.header`
  border-bottom: 1px solid;
  padding: 5px;
  background-color: #bb5ff7;
`;

export const ContainerWrapper = styled.section`
  background-repeat: no-repeat;
  background-size: cover;
`;
